if (typeof JW === 'undefined') JW = {};
JW.InpSelect = function ($, tlg)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'INPSELECT';
    _pri.uid = '';
    _pri.tid = '';    // tag id prefix
    _pri.tgrid = '';  // dom id for tgr
    _pri.lgrid = '';  // dom id for lgr
    _pri.$tlg = null;
    _pri.$sel = null; // select
    _pri.$inp = null; // text input
    _pri.Jtai = null; // JW.TAInp
    _pri.$tgr = null; // tags group
    _pri.$lgr = null; // list group (fake select)
    _pri.opts = {
        prm: '',      // data-prompt
        plh: '',      // tah input placeholder
        mlt: false,   // is multiple
        tah: false,   // select will be filled by typeahead
        url: '',      // tah ajax url
        min: 2,       // min tah query length
        exm: false,   // only accept exact matches
        ppl: 'top',   // no-exact-match warn message placement
        // not implemented cas: false,   // case sensitive input, def false //TODO! for tah at least ...
        coe: false,   // close on enter
        ttjsel: false,    // 261012 type-to-jump selects the hit at once like a native select (opt-in, data-ttjsel - not for selects submitting on change)
        mxh: 0,
        lblid: '',    // dom id for aria-labelledby ...
        spl: true,    // split by , ...
        vik: true,    // v is k for multiple selects option values ...
        lgr_to: '',   // CSS selector for dropdown attachment (e.g. 'body') — avoids modal overflow

        dbg_lvl: 1
    };
    _pri.tag_pat = '<span class="tgr-tag label label-default"></span>';
    _pri.tag_close_pat = '<i class="tag-close" tabindex="0" role="button" title="entfernen"></i>';
    _pri.tah_class = 'jws-tah';
    _pri.items_map = {};
    _pri.items_map_rev = {};
    _pri.items_map_tmp = {};
    _pri.items_map_buff = {};
    _pri.inp_buff = '';
    _pri.$tlg = $(tlg);
    _pri.key_nav_timer = 0;
    _pri.is_key_nav = false;
    _pri.inited = false;
    _pri.disabled = false;
    _pri.ttj_buff = '';     // 261010 type-to-jump: the chars typed so far, reset after a pause
    _pri.ttj_timer = 0;
    _pri.ttj_selecting = false; // 261012 data-ttjsel takes a hit: the list stays open for further typing

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.uid = JW.Page.getUId();
        _pri.tgrid = 'tgr_' + _pri.uid;
        _pri.lgrid = 'lgr_' + _pri.uid;
        _pri.tid = 'tag-' + _pri.uid + '-';
        // _pri.dbg('******** init() uid: ' + _pri.uid + ' ***');

        _pri.$sel = _pri.$tlg.find('select');
        if (_pri.$sel.length != 1)
        {
            _pri.dbg('!!! init(): missing select - return!');
            _pri.dbg('    $tlg: ', _pri.$tlg);
            return;
        }

        _pri.$sel.data('InpSelect', publ);

        if (typeof _pri.$sel.data('prompt') != 'undefined')
        {
            _pri.opts.plh = _pri.$sel.data('prompt');
            _pri.opts.prm = '<span class="tags-group-prompt">' + _pri.$sel.data('prompt') + '</span>';
        }

        if (typeof _pri.$sel.data('coe') != 'undefined' && _pri.$sel.data('coe'))
        {
            _pri.opts.coe = true;
        }

        if (typeof _pri.$sel.data('ttjsel') != 'undefined' && _pri.$sel.data('ttjsel'))
        {
            _pri.opts.ttjsel = true;
        }

        if (typeof _pri.$sel.data('spl') === 'boolean')
        {
            _pri.opts.spl = _pri.$sel.data('spl');
        }

        if (typeof _pri.$sel.data('vik') === 'boolean')
        {
            _pri.opts.vik = _pri.$sel.data('vik');
        }

        if (typeof _pri.$sel.data('lblid') != 'undefined' && _pri.$sel.data('lblid'))
        {
            _pri.opts.lblid = _pri.$sel.data('lblid');
        }

        if (typeof _pri.$sel.data('lgr_to') === 'string' && _pri.$sel.data('lgr_to') != '')
        {
            _pri.opts.lgr_to = _pri.$sel.data('lgr_to');
        }

        if (typeof _pri.$sel.data('mxh') != 'undefined')
        {
            var mxh = parseInt(_pri.$sel.data('mxh'));
            if (mxh > 0)
            {
                _pri.opts.mxh = mxh;
            }
        }

        if (typeof _pri.$sel.data('min') != 'undefined')
        {
            var min = parseInt(_pri.$sel.data('min'));
            // _pri.dbg('*** min found - set to :', min);
            _pri.opts.min = min;
        }

        if (typeof _pri.$sel.data('url') != 'undefined' && _pri.$sel.data('url') != '')
        {
            _pri.opts.tah = true;
            _pri.opts.url = _pri.$sel.data('url');
            if (typeof _pri.$sel.data('exm') != 'undefined' && _pri.$sel.data('exm'))
            {
                _pri.opts.exm = true;
                if (typeof _pri.$sel.data('ppl') != 'undefined' && _pri.$sel.data('ppl') != '')
                {
                    _pri.opts.ppl = _pri.$sel.data('ppl');
                }
            }
        }

        _pri.opts.mlt = (typeof _pri.$sel.attr('multiple') != 'undefined');

        _pri.$tgr = $('<div id="' + _pri.tgrid + '" class="vinp tags-group" tabindex="0" role="combobox" aria-haspopup="listbox" aria-expanded="false"><i class="ico-exp fa fa-caret-down" aria-hidden="true"></i></div>').insertBefore(_pri.$sel);

        if (_pri.opts.tah)
        {
            _pri.$tgr.addClass(_pri.tah_class);
        }

        if (typeof _pri.$sel.data('cls') != 'undefined')
        {
            _pri.$tgr.addClass(_pri.$sel.data('cls'));
        }

        if (_pri.opts.lblid != '')
        {
            // $('#' + _pri.opts.lblid).attr('for', _pri.tgrid); // only for form elements? ...
            _pri.$tgr.attr('aria-labelledby', _pri.opts.lblid);
        }
        else if (_pri.opts.plh != '')
        {
            _pri.$tgr.attr('aria-label', _pri.opts.plh);
        }

        //_pri.dbg('tgr: ', _pri.$tgr);

        _pri.lgrCreate();

        if (!_pri.opts.tah)
        {
            // programmatically remove options won't trigger ... !? also not by line below ...
            // _pri.$tlg.on('change', 'select', function()
            _pri.$sel.change(publ.optionsChanged);
        }

        $(document).click(function (e)
        {
            if (_pri.disabled)
            {
                return;
            }

            //_pri.dbg('         document.on(click)');
            if (_pri.$lgr.is(":visible") || (_pri.$tgr.hasClass('active') && _pri.opts.tah && !_pri.opts.mlt))
            {
                if (_pri.opts.mlt)
                {
                    // if the target of the click isn't the container && nor a descendant of the container
                    if (!_pri.$lgr.is(e.target) && !_pri.$tgr.is(e.target)
                        && _pri.$lgr.has(e.target).length === 0 && _pri.$tgr.has(e.target).length === 0)
                    {
                        //_pri.dbg('*** hide lgr!');
                        //_pri.addTagManual(); // do not add a remaining word after blur ???
                        _pri.lgrClose();
                        _pri.inpBlur();
                    }
                }
                else
                {
                    if (!_pri.$tgr.is(e.target) && _pri.$tgr.has(e.target).length === 0
                        && (_pri.$inp == null || (!_pri.$inp.is(e.target) && _pri.$inp.has(e.target).length === 0)))
                    {
                        // _pri.dbg('*** hide lgr!');

                        _pri.addTagManual();
                        _pri.lgrClose();
                    }
                }
            }
        });

        $(document).on('keydown', function (e)
        {
            _pri.dbgG('*** document on keydown');

            if (_pri.disabled)
            {
                return;
            }

            if (_pri.$lgr.is(":visible"))
            {
                _pri.dbg('    lgr is visible ...');

                // 261010 type-to-jump (printable keys; space only continues a search an entry goes on
                // with, else it selects) - only for keys aimed at this control while it is open: not
                // while it closes, not for another field focused meanwhile
                if (!_pri.opts.tah && _pri.$tgr.attr('aria-expanded') === 'true' && _pri.isOwnElm(e.target) && _pri.isTtjKey(e))
                {
                    e.preventDefault();
                    _pri.ttjAdd(e.key);
                    _pri.ttjApply();
                    return false;
                }

                var kc = e.keyCode;
                if (kc == 40 || kc == 38) // DOWN UP
                {
                    _pri.dbg('    kc = ' + kc + ', DOWN / UP');
                    if (!_pri.opts.tah)
                    {
                        //_pri.dbg('document catched keycode: ', kc);
                        e.preventDefault();
                        //_pri.$lgr.focus();
                        _pri.lgrKeyNav(kc);
                        return false;
                    }
                }
                else if (kc == 9) // TAB
                {
                    _pri.dbg('    kc = 9, TAB');
                    if (_pri.opts.tah)
                    {
                        _pri.addTagManual();
                        _pri.lgrClose();
                    }
                    else
                    {
                        // var $item = _pri.$lgr.find('.lgr-itm.focus');
                        // if ($item.length == 1)
                        // {
                        //     _pri.dbg('    item trigger CLICK');
                        //     $item.trigger('click');
                        // }
                        var $elm = _pri.$lgr.find('.lgr-itm.focus');
                        _pri.dbg('    elm focus:', $elm);
                        // if ($elm.length == 0)
                        // {
                        //     $elm = _pri.$lgr.find('.lgr-itm').first();
                        //     if ($elm.length == 1)
                        //     {
                        //         e.preventDefault();
                        //         $elm.focus();
                        //         return false;
                        //     }
                        // }
                        // 261010 edge = no navigable entry left in that direction (lgrKeyNav skips
                        // disabled / hidden ones, a disabled first / last row is never reached)
                        var nav_sel = '.lgr-itm:not(.disabled):not(.hidden)';
                        var at_edge = ($elm.length > 0 && (e.shiftKey ? $elm.prevAll(nav_sel) : $elm.nextAll(nav_sel)).length == 0);
                        if (at_edge && e.shiftKey)
                        {
                            _pri.dbg('    first entry has focus ...');
                            e.preventDefault();
                            _pri.lgrClose(function() {
                                _pri.$tgr.focus();
                            });
                            return false;
                        }
                        else if (at_edge && !e.shiftKey)
                        {
                            _pri.dbg('    last entry has focus ...');
                            _pri.lgrClose();
                        }
                        else
                        {
                            e.preventDefault();
                            var vkc = e.shiftKey ? 38 : 40;
                            _pri.lgrKeyNav(vkc);
                            return false;
                        }
                    }
                    // _pri.lgrClose();
                }
                else if (kc == 13 || kc == 32) // ENTER / SPACE
                {
                    _pri.dbg('    kc = 13, ENTER / SPACE');

                    if (!_pri.opts.tah)
                    {
                        e.preventDefault();
                        var $item = _pri.$lgr.find('.lgr-itm.focus');
                        if ($item.length == 1)
                        {
                            _pri.dbg('    item trigger CLICK');
                            $item.trigger('click');
                        }
                        if (!_pri.opts.mlt)
                        {
                            _pri.lgrClose();
                        }
                        return false;
                    }
                }
                else if (kc == 27) // ESC
                {
                    if (_pri.opts.tah)
                    {
                        // ? do not add the remainder on blur ...?
                        //_pri.$inp.val(_pri.inp_buff);
                        //_pri.addTagManual();
                        _pri.inpBlur();
                    }
                    _pri.lgrClose();
                }
                else if (kc == 8) // BACKSPACE
                {
                    if (!_pri.opts.tah)
                    {
                        e.preventDefault();
                        return false;
                    }
                    else if (_pri.opts.tah && !_pri.$inp.is(':focus'))
                    {
                        e.preventDefault();
                        _pri.$inp.focus();
                        //_pri.$inp.val(_pri.$inp.val());
                        return false;
                    }

                }
            }
        });

        _pri.$tgr.on('click', _pri.tgrClick);
        // 261010 type-to-jump on the closed control: open the list and jump right away (slideDown
        // shows the list at once, only its height is animated)
        _pri.$tgr.on('keydown', function(e)
        {
            if (!_pri.disabled && !_pri.opts.tah && !_pri.$lgr.is(":visible") && e.key !== ' ' && _pri.isTtjKey(e))
            {
                e.preventDefault();
                _pri.ttjAdd(e.key);
                _pri.$tgr.trigger('click');
                _pri.ttjApply();
                return false;
            }
        });
        _pri.$tgr.on('keyup', function(e)
        {
            _pri.dbgG('*** tgr on keyup');

            var kc = e.keyCode;
            // if (e.keyCode == 9) // TAB
            if (kc == 13 || kc == 32 || kc == 40 || kc == 38) // ENTER SPACE DOWN UP
            {
                if (!_pri.$lgr.is(":visible"))
                {
                    _pri.dbg('*** keyup down/up -> trigger tgr click');
                    _pri.$tgr.trigger('click');
                }
            }
        });
        _pri.$tgr.on('focusout', function(e)
        {
            _pri.dbg('*** tgr on focusout');

            if (!_pri.$lgr.is(":visible"))
            {
                _pri.$tgr.removeClass('active');
            }
        });
        _pri.$tgr.on('focusin', function(e)
        {
            _pri.dbg('*** tgr on focusin');

            _pri.$tgr.addClass('active');
        });

        if (!_pri.opts.mlt)
        {
            _pri.$tlg.addClass('single');
        }

        _pri.checkPrompt();
        _pri.$sel.change();

        JW.Page.on('page:resize_done', function(e) {
            _pri.lgrClose();
        });
    };

    publ.optionsChanged = function()
    {
        _pri.dbgG('*** optionsChanged()');

        //_pri.dbg('vals: ', _pri.$sel.val());
        // 261012 not while type-to-jump takes a hit (data-ttjsel) - the user may go on typing
        if (!_pri.opts.mlt && !_pri.ttj_selecting)
        {
            _pri.lgrClose();
        }
        _pri.items_map_tmp = {};

        _pri.$sel.find('option:selected').each(function ()
        {
            var $this = $(this);
            if ($this.length)
            {
                //var selText = $this.text();
                //_pri.dbg(selText, $this.val());
                _pri.items_map_tmp[md5($this.val())] = { val: $this.val(), txt: $this.text() };
            }
        });
        _pri.changeTags();
    };

    _pri.tgrClick = function(e)
    {
        // _pri.dbg('******** tgrClick()');

        // e.preventDefault();
        // e.stopPropagation();

        if (_pri.disabled)
        {
            return;
        }

        if(e.type == "click")
        {
            // _pri.dbg('click');
        }
        else
        {

        }

        if (_pri.$tgr.is(e.target) || _pri.$tgr.find('.tags-group-prompt').is(e.target) || _pri.$tgr.find('span.single').is(e.target) || _pri.$tgr.find('input.jb-tah-inp').is(e.target))
        {
            if (_pri.opts.tah && !_pri.opts.mlt && !_pri.$lgr.is(":visible"))
            {
                _pri.$tgr.addClass('active');
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
                _pri.$inp.trigger('input');
            }
            else
            {
                if (_pri.$lgr.is(":visible"))
                {
                    _pri.addTagManual();
                    _pri.lgrClose();
                }
                else
                {
                    _pri.lgrOpen();
                }
            }
        }
    };

    // sometimes those keys visible for the form aren't really keys and we
    // need the values instead, but iterating over selected options isn't convenient at all
    publ.getItemsMap = function()
    {
        return _pri.items_map;
    };

    publ.on = function(enm, cb)
    {
        if (_pri.inited)
        {
            // _pri.dbg('******** on set cb to ' + enm);

            _pri.$tlg.on(enm, cb);
        }
    };

    publ.setDataUrl = function($url)
    {
        _pri.opts.tah = true;
        _pri.opts.url = $url;
        if (typeof _pri.$sel.data('exm') != 'undefined' && _pri.$sel.data('exm'))
        {
            _pri.opts.exm = true;
            if (typeof _pri.$sel.data('ppl') != 'undefined' && _pri.$sel.data('ppl') != '')
            {
                _pri.opts.ppl = _pri.$sel.data('ppl');
            }
        }
    };

    publ.setDisabled = function(dis)
    {
        _pri.disabled = dis;
    };

    /*
     * click close button on tags for multiple
     */
    _pri.tagCloseClick = function(kval)
    {
        var o = _pri.items_map[kval];

        if (!_pri.opts.tah)
        {
            _pri.$sel.find("option[value='" + o.val + "']").prop("selected", false);
            _pri.$sel.change();
        }
        else
        {
            _pri.removeTag(kval);
            _pri.syncItemsMap2TgrSel();
        }

        if (_pri.opts.tah && !_pri.$lgr.is(":visible"))
        {
            // _pri.dbg('trigger inpselect:tags_changed');
            _pri.$tlg.trigger('inpselect:tags_changed');
        }
    };

    _pri.changeTags = function()
    {
        _pri.dbgG('*** changeTags()');
        _pri.dbg('        items_map:', _pri.items_map);
        _pri.dbg('    items_map_tmp:', _pri.items_map_tmp);

        var p;
        for (p in _pri.items_map)
        {
            if (!_pri.items_map_tmp.hasOwnProperty(p))
            {
                _pri.dbg('    remove tag p:', p);
                _pri.removeTag(p);
            }
        }
        for (p in _pri.items_map_tmp)
        {
            if (!_pri.items_map.hasOwnProperty(p))
            {
                _pri.dbg('    add tag p:', p);
                _pri.addTag(_pri.items_map_tmp[p]);
            }
        }

        //_pri.dbg('items_map: ', _pri.items_map);
        //_pri.dbg('END-changeTags()');
    };

    // NEXT switch here or the call above for tah ...

    _pri.addTag = function(o)
    {
        _pri.dbgG('*** addTag() o: ', o);

        var kval = md5(o.val.toString());
        var ktxt = md5(o.txt.toString());
        // _pri.dbg('    kval: [' + kval + ']');
        // _pri.dbg('    ktxt: [' + ktxt + ']');
        // _pri.dbg('    items_map:', _pri.items_map);
        if (_pri.items_map.hasOwnProperty(kval))
        {
            // _pri.dbg('    kval exists ... return.');
            return;
        }
        _pri.items_map[kval] = o;
        _pri.items_map_rev[ktxt] = o.val;

        if (_pri.opts.tah && !_pri.opts.mlt)
        {
            _pri.$inp.val(o.txt);
            _pri.$inp.blur();
            return;
        }

        _pri.checkPrompt();

        var $tag;
        if (_pri.opts.mlt)
        {
            $tag = $('<span id="' + _pri.tid.toString() + kval + '" class="tgr-tag label label-default"></span>');
            $tag.html(o.txt + _pri.tag_close_pat);
            $tag.find('i.tag-close').on('click keyenter keyspace', function(e)
            {
                e.preventDefault();
                _pri.tagCloseClick(kval);
                return false;
            });
        }
        else
        {
            $tag = $('<span id="' + _pri.tid.toString() + kval + '" class="single"></span>');
            $tag.html(o.txt);
            if (!_pri.opts.tah && (o.val == '' || _pri.$sel.find("option[value='" + o.val + "']").hasClass('tags-group-prompt')))
            {
                $tag.addClass('tags-group-prompt');
            }
            // 261012 the option title as tooltip of the shown entry, like in the list
            var ttl = _pri.$sel.find("option[value='" + o.val + "']").attr('title');
            if (ttl)
            {
                $tag.attr('title', ttl);
            }
        }
        _pri.$tgr.append($tag);
    };

    _pri.addTagManual = function()
    {
        _pri.dbgG('*** addTagManual()');

        if (!_pri.opts.tah || '' == $.trim(_pri.$inp.val()))
        {
            return false;
        }

        var arr;

        if (_pri.opts.mlt)
        {
            if (_pri.opts.spl)
            {
                arr = _pri.$inp.val().split(',');
            }
            else
            {
                arr = [_pri.$inp.val()];
            }

            if (0 == arr.length)
            {
                return false;
            }

            _pri.$inp.val('');
            //_pri.lgrClear();
        }
        else
        {
            var p;
            for (p in _pri.items_map)
            {
                _pri.removeTag(p);
            }

            arr = [_pri.$inp.val()];
        }

        $.each(arr, function(k, v)
        {
            var txt = $.trim(v);
            var ktxt = md5(txt);

            //_pri.dbg('*** _pri.addTagManual() txt: ', txt);
            if (ktxt in _pri.items_map_rev)
            {
                _pri.removeTag(md5(_pri.items_map_rev[ktxt]));
                return 'continue'; // ugly continue equivalent ...
            }

            var obj = null;

            if (txt.length > 1)
            {
                var id = _pri.Jtai.getIdFor(txt);
                if (id == '')
                {
                    if (_pri.opts.exm)
                    {
                        _pri.jssNoMatch();
                        return false;
                    }
                    else
                    {
                        id = '_' + JW.Page.getUId();
                    }
                }
                obj = {val: id, txt: txt};

                //_pri.dbg('    obj: ', obj);
            }
            else if (_pri.opts.exm)
            {
                _pri.jssNoMatch();
                return false;
            }

            if (obj != null)
            {
                _pri.addTag(obj);
            }
        });

        _pri.syncItemsMap2TgrSel();
    };

    _pri.jssNoMatch = function()
    {
        // _pri.dbg('******** jssNoMatch()');

        var cur_val = _pri.$inp.val();
        _pri.$inp.val('');
        _pri.$inp.popover({
            content: '<b>"' + cur_val + '"</b> konnte nicht gefunden werden. Bitte wählen Sie einen entsprechenden Eintrag aus den Vorschlägen aus.',
            title: 'Hinweis <span class="close">&times;</span>',
            html: true,
            //placement: _pri.opts.ppl,
            placement: function(dn, te) {
                            if (JW.ViewPort.isgt('md'))
                            {
                                return _pri.opts.ppl;
                            }
                            return 'top';
                       },
            trigger: 'manual'
        }).on('shown.bs.popover', function(e) {
            // _pri.dbg('on shown.bs.popover e:', e);
            // _pri.dbg('    ', _pri.$inp.data('bs.popover'));
            var $tip = $(_pri.$inp.data('bs.popover').tip);
            // _pri.dbg('    tip:', $tip);
            $tip.find('.close').on('click', function(e) {
                _pri.$inp.popover('hide');
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
            });
        });
        _pri.$inp.popover("show");
    };

    _pri.removeTag = function(kval)
    {
        // _pri.dbg('*** _pri.removeTag() kval: ', kval);
        // _pri.dbg('    kval: [' + kval + ']');
        if (!_pri.items_map.hasOwnProperty(kval))
        {
            return;
        }
        var o    = _pri.items_map[kval];
        // _pri.dbg('    o:', o);
        var ktxt = md5(o.txt.toString());
        // _pri.dbg('    ktxt: [' + ktxt + ']');
        delete _pri.items_map_rev[ktxt];
        delete _pri.items_map[kval];
        $('#' + _pri.tid.toString() + kval + '').remove();
        _pri.checkPrompt();
    };

    _pri.syncItemsMap2TgrSel = function()
    {
        _pri.dbgG('*** syncItemsMap2TgrSel()');

        _pri.$sel.find('option').remove();
        _pri.$lgr.find('.list-group-item.active').removeClass('active');
        $.each(_pri.items_map, function(k, v)
        {
            // _pri.dbg('    items_map k:', k, 'v:', v);
            if (!_pri.opts.tah)
            {
                _pri.$sel.append('<option value="'+v.val+'" selected="selected">'+v.txt+'</option>');
                if (true || _pri.opts.mlt)
                {
                    _pri.$lgr.find(".list-group-item[data-value='"+v.val+"']").addClass('active').attr('aria-selected', 'true');
                }
            }
            else
            {
                if (_pri.opts.vik)
                {
                    _pri.$sel.append('<option value="'+v.txt+'" selected="selected">'+v.txt+'</option>');
                    if (true || _pri.opts.mlt)
                    {
                        _pri.$lgr.find(".list-group-item[data-value='"+md5(v.val)+"']").addClass('active').attr('aria-selected', 'true');
                    }
                }
                else
                {
                    _pri.$sel.append('<option value="'+v.val+'" selected="selected">'+v.txt+'</option>');
                    if (true || _pri.opts.mlt)
                    {
                        _pri.$lgr.find(".list-group-item[data-value='"+v.val+"']").addClass('active').attr('aria-selected', 'true');
                    }
                }


            }
        });
    };

    _pri.checkPrompt = function()
    {
        if (_pri.opts.prm == '' || !_pri.opts.mlt)
        {
            return;
        }

        if (Object.keys(_pri.items_map).length === 0)
        {
            if (_pri.$tgr.has('.tags-group-prompt').length === 0)
            {
                _pri.$tgr.append(_pri.opts.prm);
            }
        }
        else
        {
            _pri.$tgr.find('.tags-group-prompt').remove();
        }
    };

    _pri.lgrCreate = function()
    {
        _pri.$lgr = $('<ul id="' + _pri.lgrid + '" role="listbox" tabindex="-1">').addClass('list-group anim jb-dd');

        if (_pri.opts.lblid != '')
        {
            _pri.$lgr.attr('aria-labelledby', _pri.opts.lblid);
        }
        else if (_pri.opts.plh != '')
        {
            _pri.$lgr.attr('aria-label', _pri.opts.plh);
        }

        if (_pri.opts.mlt)
        {
            _pri.$lgr.addClass('mlt');
            _pri.$lgr.attr('aria-multiselectable', 'true');
        }

        if (_pri.opts.tah)
        {
            _pri.$lgr.addClass('jb-tah');

            _pri.$inp = $('<input type="text" name="jb-tah-inp_' + JW.Page.getUId() + '" autocomplete="false" class="form-control jb-tah-inp" value="" placeholder="">');
            if (_pri.opts.mlt)
            {
                _pri.$inp.addClass('mlt');
                _pri.$lgr.append(_pri.$inp);
            }
            else
            {
                _pri.$tgr.addClass('jb-tah-single');
                _pri.$inp.attr('placeholder', _pri.opts.plh);
                _pri.$tgr.append(_pri.$inp);
            }
            _pri.Jtai = JW.TAInp($, _pri.$inp, {
                url: _pri.opts.url,
                min: _pri.opts.min
            });
            _pri.lgrInitOptionsTah();
        }
        else
        {
            _pri.lgrLoadOptions();
            _pri.$sel.change(_pri.lgrSetVal);
        }

        if (_pri.opts.lgr_to != '')
        {
            // viewport-anchored mode: wrap in .jb-dd-wrp and attach to target (e.g. 'body').
            // wrapping makes the existing modal-close cleanup pick it up (see jw_modal.js).
            var $tgt = $(_pri.opts.lgr_to);
            if ($tgt.length > 0)
            {
                _pri.$lgrWrap = $('<div class="jb-dd-wrp tai-mvd"></div>').append(_pri.$lgr);
                // propagate admin-scoped font (.admc) when moving out of its admin context
                if (_pri.$sel.closest('.admc').length > 0)
                {
                    _pri.$lgrWrap.addClass('admc');
                }
                $tgt.append(_pri.$lgrWrap);
                _pri.$lgr.css({position: 'fixed', zIndex: 1000001});
            }
            else
            {
                _pri.$sel.before(_pri.$lgr);
            }
        }
        else
        {
            _pri.$sel.before(_pri.$lgr);
        }
        _pri.$sel.hide();
        _pri.$lgr.hide();
        _pri.lgrInit();
        if (_pri.opts.tah)
        {
            _pri.inpInit();
        }
    };

    _pri.lgrInit = function()
    {
        // _pri.dbg('******** lgrInit()');

        _pri.$lgr.on('click', '.lgr-itm', function (e)
        {
            _pri.dbgG('*** lgr-item click()');

            var $item = $(this);

            _pri.dbg('    item:', $item);

            if (!$item.hasClass('disabled'))
            {
                var add = true;

                if (_pri.opts.mlt)
                {
                    add = !$item.hasClass('active');
                }

                if (_pri.opts.tah)
                {
                    _pri.lgrItemClickTah($item, add);
                }
                else
                {
                    _pri.lgrItemClick($item.data('value'), add);
                }
            }

            //$item.blur();
            return false;
        });

        _pri.$lgr.on('mouseenter', '.lgr-itm', function (e)
        {
            // _pri.dbg('    on mouseenter');

            if (!_pri.is_key_nav)
            {
                _pri.$lgr.find('.lgr-itm.focus').removeClass('focus');
                $(this).addClass('focus');
            }
        });
        _pri.$lgr.on('mouseleave', '.lgr-itm', function (e)
        {
            //_pri.dbg('mouseleave');
            $(this).removeClass('focus');
        });
    };

    _pri.lgrLoadOptions = function()
    {
        _pri.lgrClear();
        _pri.$sel.find('option').each(function (i, item)
        {
            var $item = $(item);

            var $new = $('<li tabindex="0">')
                        .addClass('lgr-itm')
                        .addClass('list-group-item')
                        .attr('data-value', $item.val())
                        .text($item.text());

            if ($item.is(':disabled'))
            {
                // 261010 no tab stop either (the arrow keys skip it as well)
                $new.addClass('disabled').attr('tabindex', '-1');
            }
            else
            {
                $new.attr('role', 'option');
            }

            if ($item.css('display') === 'none')
            {
                $new.addClass('hidden');
            }

            // 261012 the option title as tooltip of the row (e.g. the country name of a code)
            if ($item.attr('title'))
            {
                $new.attr('title', $item.attr('title'));
            }

            // if ($item.hasClass('tags-group-prompt'))
            // {
            //     $new.addClass('tags-group-prompt');
            // }

            $new.addClass($item.attr("class"));

            _pri.$lgr.append($new);
        });
    };

    _pri.lgrInitOptionsTah = function()
    {
        _pri.dbgG('*** lgrInitOptionsTah()');

        _pri.lgrClear();
        _pri.items_map_tmp = {};
        _pri.$sel.find('option').each(function (i, item)
        {
            var $item = $(item);
            _pri.dbg('    item  val():', $item.val());
            _pri.dbg('    item text():', $item.text());
            if ($item.val() != '' && $item.text() != '' && !$item.is(':disabled') && $item.css('display') !== 'none')
            {
                _pri.items_map_tmp[md5($item.val())] = {val: $item.val(), txt: $item.text()};
                _pri.Jtai.initRecord({id: $item.val(), label: $item.text()});
            }
        });
        _pri.changeTags();
        //_pri.dbg('END-lgrInitOptionsTah()');
    };

    _pri.stripTags = function(str)
    {
        return str.replace(/[<>]/g, '');
    };

    _pri.inpInit = function()
    {
        // _pri.dbg('******** inpInit()');

        _pri.$inp.on('focusin', function()
        {
            // _pri.dbg('    $inp.on(focusin)');
            _pri.$tgr.addClass('active');
            if (_pri.opts.min == 0)
            {
                _pri.$inp.trigger('input');
            }
        });

        _pri.$inp.on('input', function(e)
        {
            //_pri.dbg('    $inp.on(input)');

            _pri.$inp.val(_pri.stripTags(_pri.$inp.val()));

            _pri.inp_buff = _pri.$inp.val();

            //_pri.dbg(_pri.$inp.data('bs.popover'));
            if (typeof _pri.$inp.data('bs.popover') != 'undefined')
            {
                _pri.$inp.popover('dispose');
            }
            var query = _pri.cleanQuery(_pri.$inp.val());
            if (query.length < _pri.opts.min)
            {
                if (_pri.opts.tah && !_pri.opts.mlt)
                {
                    //_pri.dbg('_pri.$inp.on input -> lgr.close');
                    _pri.lgrClose();
                }
                _pri.lgrClear();
                return false;
            }
            _pri.Jtai.onInput(query);
        });

        _pri.$inp.on('tai:response', function(e, q)
        {
            _pri.dbgG('    inp.on(tai:response)');

            var query = _pri.cleanQuery(_pri.$inp.val());
            //_pri.dbg('******** tai:response *** q: ', q, ' query: ', query);
            if (q != query)
            {
                // delayed response ...
                //_pri.dbg('!!! delayed response ...');
                return;
            }

            _pri.lgrClear();

            var arr = _pri.Jtai.getItemsList(query);
            _pri.dbg('    Jtai.getItemsList():', arr);

            $.each(arr, function(k, v)
            {
                var $new = $('<li role="option">')
                            .addClass('lgr-itm')
                            .addClass('list-group-item')
                            .attr('data-value', v.id)
                            .attr('data-label', v.label)
                            .html(_pri.markMatch(v.label, query));

                // if (md5(v.id) in _pri.items_map && _pri.opts.mlt)// || (!_pri.opts.mlt && v.label == query))
                if (md5(v.label) in _pri.items_map_rev && _pri.opts.mlt)// || (!_pri.opts.mlt && v.label == query))
                {
                    $new.addClass('active').attr('aria-selected', 'true');
                }
                else
                {
                    $new.attr('aria-selected', 'false');
                }

                _pri.$lgr.append($new);
            });

            if (_pri.$tgr.hasClass('active'))
            {
                if (arr.length > 0 && !_pri.$lgr.is(":visible"))
                {
                    _pri.lgrOpen();
                }
                else if (arr.length == 0 && _pri.$lgr.is(":visible") && _pri.opts.tah && !_pri.opts.mlt)
                {
                    _pri.lgrClose();
                }
            }
        });

        _pri.$inp.on('keydown', function(e)
        {
            //_pri.dbg('    $inp.on(keydown)');
            var kc = e.keyCode;
            if (kc == 13)
            {
                e.preventDefault();
                _pri.addTagManual();
                if (!_pri.opts.mlt || _pri.opts.coe)
                {
                    _pri.lgrClose();
                }
                return false;
            }
            else if (kc == 38 || kc == 40)
            {
                e.preventDefault();
                //_pri.$lgr.focus();
                _pri.lgrKeyNav(kc);
                return false;
            }
        });
    };

    _pri.inpBlur = function()
    {
        if (_pri.$inp != null)
        {
            _pri.$inp.val('');
        }
    };

    _pri.markMatch = function(str, query)
    {
        var rx = new RegExp(RegExp.escape(query), 'i');
        return str.replace(rx, '<b>' + "$&" + '</b>');
    }

    _pri.cleanQuery = function(str)
    {
        return str.replace(/ \|.*$/, '');
    };

    _pri.lgrClear = function()
    {
        // _pri.dbg('******** lgrClear()');

        _pri.$lgr.find('li').remove();
    };

    _pri.lgrItemClick = function(v, add)
    {
        // _pri.dbg('******** lgrItemClick() v: ', v);

        var values;

        if (!_pri.opts.mlt)
        {
            values = v;
        }
        else
        {
            values = [];

            _pri.$lgr.find('.list-group-item.active').each(function(i, item)
            {
                var value = $(item).data('value');
                if (add || value != v)
                {
                    values.push(value);
                }
            });

            if (add)
            {
                values.push(v);
            }

            if (values.length == 1)
            {
                values = values[0];
            }
        }

        //_pri.dbg('lgrItemClick() values: ', values);
        _pri.$sel.val(values);
        _pri.$sel.change();
    }

    _pri.lgrItemClickTah = function($item, add)
    {
        _pri.dbgG('*** lgrItemClickTah() add?', add);
        _pri.dbg('    items_map:', _pri.items_map);

        var o = { val: $item.data('value').toString(), txt: $item.text() };
        _pri.dbg('    o: ', o);


        _pri.items_map_tmp = {};

        if (!_pri.opts.mlt)
        {
            _pri.dbg('    no mlt ...');

            _pri.items_map_tmp[md5(o.val)] = o;
            _pri.$inp.val(o.txt);
            _pri.$inp.trigger('input');
        }
        else
        {
            $.each(_pri.items_map, function(k, v)
            {
                _pri.dbgY('    k: ', k);
                if (add || o.txt != v.txt)
                {
                    _pri.dbgR('    keep ', o.txt);
                    _pri.items_map_tmp[md5(v.val)] = v;
                }
                else
                {
                    _pri.dbgR('    skip ', o.txt);
                }
            });

            if (add)
            {
                _pri.items_map_tmp[md5(o.val)] = o;

                // maybe it's cleaner to preserve input and results list ...?
                //_pri.$inp.val(o.txt);
                //_pri.$inp.trigger('input');
                //_pri.$inp.val('');
                if (!_pri.opts.exm)
                {
                    //??? _pri.$inp.focus();
                }
            }
        }

        if (!_pri.opts.mlt)
        {
            _pri.lgrClose();
        }

        //_pri.dbg('    items_map: ',_pri.items_map);
        //_pri.dbg('    items_map_tmp: ',_pri.items_map_tmp);

        _pri.changeTags();
        _pri.syncItemsMap2TgrSel();
    }

    // not used for tah ...
    _pri.lgrSetVal = function()
    {
        _pri.dbgG('*** lgrSetVal()');

        var map = {};
        var val = _pri.$sel.val();
        //_pri.dbg('*** _pri.lgrSetVal() ***', val);
        var val_changed = false;

        if (typeof val === 'string')
        {
            val = [val];
        }

        if (Array.isArray(val))
        {
            var v;
            var $lgri;
            for (var i in val)
            {
                v = val[i];
                map[v] = 1;
                $lgri = _pri.$lgr.find(".list-group-item[data-value='" + v + "']");
                if ($lgri.length > 0 && !$lgri.hasClass('active'))
                {
                    val_changed = true;
                    $lgri.addClass('active');
                }
            }
        }

        // _pri.$lgr.find('.list-group-item.active').each(function(i, item)
        // {
        //     var $item = $(item);
        //     if (!map.hasOwnProperty($item.data('value')))
        //     {
        //         val_changed = true;
        //         $item.removeClass('active');
        //     }
        // });

        _pri.$lgr.find('.list-group-item').each(function(i, item)
        {
            var $item = $(item);

            if ($item.hasClass('active'))
            {
                if (!map.hasOwnProperty($item.data('value')))
                {
                    val_changed = true;
                    $item.removeClass('active');
                    $item.attr('aria-selected', 'false');
                }
                else
                {
                    $item.attr('aria-selected', 'true');
                }
            }
            else
            {
                $item.attr('aria-selected', 'false');
            }
        });

        if (val_changed)
        {
            // _pri.dbg('         val_changed');

            _pri.$tlg.trigger('inpselect:val_changed');
        }
    };

    // 261010 type-to-jump like a native select: the typed chars (reset after a pause) jump to the
    // first entry starting with them, else - from two chars on - to the first containing them
    // (e.g. a city within a longer label); a single char - also typed repeatedly - cycles through
    // the entries starting with it, beginning after the focused one

    // the element (event target) belongs to this control: its trigger or its list
    _pri.isOwnElm = function(elm)
    {
        return (_pri.$lgr.is(elm) || _pri.$lgr.has(elm).length > 0 || _pri.$tgr.is(elm) || _pri.$tgr.has(elm).length > 0);
    };

    // the text an entry is matched against: soft hyphens are invisible, nbsp looks like a space;
    // 261012 plus its title if it has one (country codes are found by their names, 'schw' -> CH)
    _pri.ttjTxt = function(itm)
    {
        var ttl = $(itm).attr('title');
        return (ttl ? $(itm).text() + ' ' + ttl : $(itm).text()).replace(/­/g, '').replace(/ /g, ' ').toLocaleLowerCase();
    };

    // a printable key; space only continues a search where an entry goes on with it ('gmbh & co'),
    // else it keeps selecting the focused entry
    _pri.isTtjKey = function(e)
    {
        if (typeof e.key !== 'string' || e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey)
        {
            return false;
        }
        if (e.key !== ' ')
        {
            return true;
        }
        var buff = _pri.ttj_buff + ' ';
        return (buff !== ' ' && _pri.$lgr.find('.lgr-itm:not(.disabled):not(.hidden)').filter(function() { return _pri.ttjTxt(this).indexOf(buff) === 0; }).length > 0);
    };

    _pri.ttjAdd = function(chr)
    {
        clearTimeout(_pri.ttj_timer);
        _pri.ttj_buff += chr.toLocaleLowerCase();
        _pri.ttj_timer = setTimeout(function()
        {
            _pri.ttj_buff = '';
        }, 800);
    };

    _pri.ttjApply = function()
    {
        var buff = _pri.ttj_buff;
        var $as = _pri.$lgr.find('.lgr-itm:not(.disabled):not(.hidden)');
        var $hit = null;

        if (buff === '' || $as.length == 0)
        {
            return;
        }

        if (buff.split('').every(function(chr) { return chr === buff[0]; }))
        {
            var $starts = $as.filter(function() { return _pri.ttjTxt(this).indexOf(buff[0]) === 0; });
            if ($starts.length > 0)
            {
                var $nxt = _pri.$lgr.find('.lgr-itm.focus').nextAll().filter($starts).first();
                $hit = ($nxt.length > 0 ? $nxt : $starts.first());
            }
        }
        if ($hit === null)
        {
            $as.each(function() { if (_pri.ttjTxt(this).indexOf(buff) === 0) { $hit = $(this); return false; } });
        }
        if ($hit === null && buff.length > 1)
        {
            $as.each(function() { if (_pri.ttjTxt(this).indexOf(buff) > -1) { $hit = $(this); return false; } });
        }
        if ($hit === null)
        {
            return;
        }

        clearTimeout(_pri.key_nav_timer);
        _pri.is_key_nav = true;
        _pri.$lgr.find('.lgr-itm.focus').removeClass('focus');
        $hit.addClass('focus');
        $hit[0].focus({preventScroll: true});
        // the hit on top of the list, the page only moves if the list reaches beyond the viewport
        // (lists without max-height are no scroll container)
        _pri.$lgr.scrollTop(_pri.$lgr.scrollTop() + $hit.offset().top - _pri.$lgr.offset().top);
        $hit[0].scrollIntoView({block: 'nearest'});
        _pri.key_nav_timer = setTimeout(function()
        {
            _pri.is_key_nav = false;
        }, 200);

        // 261012 opt-in (data-ttjsel): the hit is taken at once like in a native select, so typing
        // and then leaving the field keeps it - else only Enter or a click take the marked entry
        if (_pri.opts.ttjsel && !_pri.opts.mlt && !_pri.opts.tah && String(_pri.$sel.val()) !== String($hit.data('value')))
        {
            _pri.ttj_selecting = true;
            _pri.lgrItemClick($hit.data('value'), true);
            _pri.ttj_selecting = false;
        }
    };

    _pri.lgrKeyNav = function(kc)
    {
        _pri.dbgG('*** lgrKeyNav() kc: ', kc);

        if (!_pri.$lgr.is(":visible"))
        {
            _pri.dbgR('    lgr not visible!');
            return;
        }

        // 261010 disabled entries (e.g. group headers) and hidden ones are skipped
        var $as = _pri.$lgr.find('.lgr-itm:not(.disabled):not(.hidden)');
        if ($as.length < 1)
        {
            return;
        }

        var $afocs = _pri.$lgr.find('.lgr-itm.focus');
        $afocs.removeClass('focus');

        var $fitem = null;

        // 261010 no early return for a single entry any more: it counts navigable entries only
        // now, with disabled ones around the single entry was out of reach (the general path
        // handles one entry: first() / last(), resp. the focused one stays)
        // if (!_pri.opts.tah && $as.length == 1)
        // {
        //     return;
        // }

        clearTimeout(_pri.key_nav_timer);
        _pri.is_key_nav = true;

        if ($afocs.length == 0)
        {
            if (kc == 40)
            {
                $fitem = $as.first();
            }
            else
            {
                $fitem = $as.last();
            }
        }
        else
        {
            if (kc == 40)
            {
                var $nxt = $afocs.nextAll('.lgr-itm:not(.disabled):not(.hidden)').first();
                if ($nxt.length > 0)
                {
                    $fitem = $nxt;
                    _pri.dbg('    lgrKeyNav() next: ', $nxt);
                }
                else
                {
                    // commented - dont wrap ...
                    // if (!_pri.opts.tah)
                    // {
                    //     $fitem = $as.first();
                    // }
                    $fitem = $afocs;
                }
            }
            if (kc == 38)
            {
                var $prv = $afocs.prevAll('.lgr-itm:not(.disabled):not(.hidden)').first();
                if ($prv.length > 0)
                {
                    $fitem = $prv;
                    _pri.dbg('    lgrKeyNav() prev: ', $prv);
                }
                else
                {
                    // commented - dont wrap ...
                    // if (!_pri.opts.tah)
                    // {
                    //     $fitem = $as.last();
                    // }
                    $fitem = $afocs;
                }
            }
        }

        if ($fitem != null)
        {
            $fitem.addClass('focus');
            // 261010 scroll only as far as needed and before focus() (which would center an entry
            // outside the view): a type-to-jump hit sits on top, the next arrow key must not pull
            // the list back to show the entry at the bottom
            var itm_top = $fitem.offset().top - _pri.$lgr.offset().top - _pri.$lgr[0].clientTop;
            var itm_bot = itm_top + $fitem.outerHeight();
            if (itm_top < 0)
            {
                _pri.$lgr.scrollTop(_pri.$lgr.scrollTop() + itm_top);
            }
            else if (itm_bot > _pri.$lgr[0].clientHeight)
            {
                _pri.$lgr.scrollTop(_pri.$lgr.scrollTop() + itm_bot - _pri.$lgr[0].clientHeight);
            }
            $fitem.focus();
            if (_pri.opts.tah)
            {
                _pri.$inp.val($fitem.text());
            }

            // _pri.dbg('    _pri.$lgr.offset().top: ', _pri.$lgr.offset().top);
            // _pri.dbg('    lgr.scrollTop()  : ', _pri.$lgr.scrollTop());
            // _pri.dbg('    item.offset().top: ', $fitem.offset().top);
            // 261010 before: always aligned at the bottom
            // _pri.$lgr.scrollTop(_pri.$lgr.scrollTop() + ($fitem.offset().top - _pri.$lgr.offset().top - _pri.$lgr.outerHeight(true) + $fitem.outerHeight(true)));
        }
        else if (_pri.opts.tah)
        {
            // fill input with original value ...
            // _pri.dbg('    fill input buffer');

            _pri.$inp.val(_pri.inp_buff);
        }

        _pri.key_nav_timer = setTimeout(function(){
            _pri.is_key_nav = false;
        }, 200);
    };

    _pri.lgrOpen = function()
    {
        _pri.dbgG('*** lgrOpen()');

        _pri.items_map_buff = $.extend({}, _pri.items_map);
        _pri.$lgr.find('.lgr-itm.focus').removeClass('focus');
        // _pri.dbg('    _pri.$lgr.outerHeight(true): ', _pri.$lgr.outerHeight(true));
        // _pri.dbg('    _pri.$tgr.offset().top: ', _pri.$tgr.offset().top);
        // _pri.dbg('    doc.height: ', JW.Page.getDocHeight());
        _pri.$lgr.css('max-height', '');
        _pri.$lgr.css('overflow-y', '');
        _pri.$lgr.css('overflow-x', '');

        // viewport-anchored mode: re-position over the trigger on every open,
        // constrain max-height to remaining viewport so the dropdown stays visible.
        var mxh;
        if (_pri.opts.lgr_to != '')
        {
            var r = _pri.$tgr[0].getBoundingClientRect();
            _pri.$lgr.css({top: r.bottom + 'px', left: r.left + 'px', width: r.width + 'px'});
            mxh = window.innerHeight - r.bottom - 20;
        }
        else
        {
            mxh = JW.Page.getDocHeight() - _pri.$tgr.offset().top - _pri.$tgr.outerHeight(true) - 20;
        }

        if (_pri.opts.mxh > 0 && _pri.opts.mxh < mxh)
        {
            _pri.$lgr.css('max-height', _pri.opts.mxh);
            _pri.$lgr.css('overflow-y', 'auto');
            if (_pri.opts.tah)
            {
                _pri.$lgr.css('overflow-x', 'hidden');
            }
        }
        else if (mxh < _pri.$lgr.outerHeight(true))
        {
            _pri.$lgr.css('max-height', mxh);
            _pri.$lgr.css('overflow-y', 'auto');
        }

        _pri.$lgr.slideDown(200, function() {
            _pri.$lgr.removeClass('anim');
            _pri.$tgr.addClass('active');
            if (_pri.opts.tah)
            {
                _pri.$inp.focus();
                //_pri.$inp.val(_pri.$inp.val());
            }
            else
            {
                _pri.$tgr.blur();
                // 261010 keep an entry focused meanwhile (type-to-jump while opening) - now that the
                // list has its full height, the page can follow to it (during the animation the
                // list is a clipping container, scrollIntoView() stopped there)
                var $fitm = _pri.$lgr.find('.lgr-itm.focus');
                if ($fitm.length > 0)
                {
                    $fitm[0].focus({preventScroll: true});
                    $fitm[0].scrollIntoView({block: 'nearest'});
                }
                else
                {
                    _pri.$lgr.focus();
                }
            }

            // // ???
            // // _pri.dbg('$(html,body).offset().top:', $('html,body').scrollTop());
            // var dff = _pri.$tgr.offset().top + _pri.$tgr.outerHeight(true) + _pri.$lgr.outerHeight(true) - ($(window).height() + $('html,body').scrollTop());
            // if (dff > 0)
            // {
            //     $('html,body').scrollTop($('html,body').scrollTop() + dff + 10);
            // }
        });

        // _pri.$tgr.find('.tgr-tag > .tag-close').blur();
        _pri.$tgr.attr('aria-expanded', 'true');
    };

    _pri.checkChanged = function()
    {
        // _pri.dbg('******** checkChanged()');

        var changed = false;
        // for now, only value changes will be taken into account ...
        var ks0 = Object.keys(_pri.items_map);
        var ks1 = Object.keys(_pri.items_map_buff);

        if (ks0.length == ks1.length)
        {
            // _pri.dbg('         same length');
            //_pri.dbg(ks0, ks1);

            var len = ks0.length;
            var i, k;
            for (i = 0; i < len; ++i)
            {
                k = ks0[i];
                /*
                _pri.dbg('     check items_map_buff k: ', k);
                _pri.dbg('     check items_map_buff has k? ', _pri.items_map_buff.hasOwnProperty(k));
                _pri.dbg('     check map, map_buff ', _pri.items_map[k], _pri.items_map_buff[k]);
                */
                if (!_pri.items_map_buff.hasOwnProperty(k) || _pri.items_map[k] != _pri.items_map_buff[k])
                {
                    changed = true;
                    break;
                }
            }
        }
        else
        {
            changed = true;
        }

        if (changed)
        {
            // _pri.dbg('trigger inpselect:tags_changed');

            _pri.$tlg.trigger('inpselect:tags_changed');
        }
        else
        {
            // _pri.dbg('        identical ...');
        }
    };

    _pri.lgrClose = function(cb)
    {
        // _pri.dbg('******** lgrClose()');

        if (!_pri.opts.tah || _pri.opts.mlt || !_pri.$inp.is(':focus'))
        {
            _pri.$tgr.removeClass('active');
            _pri.checkChanged();
        }

        // 261010 a type-to-jump search ends with the list
        clearTimeout(_pri.ttj_timer);
        _pri.ttj_buff = '';

        _pri.$lgr.addClass('anim');
        _pri.$lgr.slideUp(200, function() {
            if (typeof cb === 'function')
            {
                cb();
            }
        });

        _pri.$tgr.attr('aria-expanded', 'false');
    };

    _pri.extend();
    _pri.init();
    return publ;
};
